/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Component imports
import { Button, Col, Row, Tooltip, Typography } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

// Misc imports
import AnalyticsTable from '../Tables/AnalyticsTable';
import exportAnalyticsData from '../../utils/misc/exportAnalyticsData';

const MissedQuestionsTopHundredSection = ({ data = [], sectionTitle = '', isLoading = true, renderOnlyTable = false }) => {
  const { t } = useTranslation();

  const [sortedInfo, setSortedInfo] = useState({ order: '', columnKey: '' });

  const handleTableChange = (_pagination, _filters, sorter) => {
    setSortedInfo(sorter);
  };

  const tableConfig = {
    tableData: data,
    isDescriptionTable: false,
    isTableLoading: isLoading,
    emptyLines: 0,
    noScroll: data?.length < 8,
    scroll: data?.length > 8 ? 280 : null,
    tableColumns: [
      {
        title: t('Question'),
        dataIndex: 'name',
        key: 'name',
        width: '70%',
        align: 'left',
        sorter: (a, b) => a.name.localeCompare(b.name),
        sortOrder: sortedInfo.columnKey === 'name' && sortedInfo.order,
        render: (record) => {
          if (!record) {
            return `(${t('Empty Input')})`;
          } else {
            return record;
          }
        },
        ellipsis: true
      },
      {
        title: t('Appearances'),
        dataIndex: 'count',
        key: 'count',
        width: '30%',
        align: 'center',
        ellipsis: true,
        sorter: (a, b) => a.count - b.count,
        sortOrder: sortedInfo.columnKey === 'count' && sortedInfo.order
      }
    ]
  };

  return renderOnlyTable ? (
    <AnalyticsTable
      tableData={tableConfig.tableData}
      isDescriptionTable={tableConfig.isDescriptionTable}
      isTableLoading={tableConfig.isTableLoading}
      emptyLines={tableConfig.emptyLines}
      tableColumns={tableConfig.tableColumns}
      noScroll={tableConfig.noScroll}
      onChange={handleTableChange}
    />
  ) : (
    <Fragment>
      <Row justify="space-between">
        <Col className="mb-6 position-relative">
          <Typography.Title level={4} className="mb-6">
            <Typography.Text className="mr-2">{sectionTitle}</Typography.Text>
          </Typography.Title>
        </Col>
        <Col>
          <Tooltip title={tableConfig.tableData.length === 0 ? t('There are no analytics to export') : t('Export as CSV')}>
            <Button
              type="text"
              size="large"
              onClick={() => exportAnalyticsData(tableConfig, 'automated_answers', sectionTitle)}
              loading={tableConfig.isTableLoading}
              disabled={tableConfig.tableData.length === 0}
              icon={<DownloadOutlined />}
            />
          </Tooltip>
        </Col>
      </Row>

      <AnalyticsTable
        tableData={tableConfig.tableData}
        isDescriptionTable={tableConfig.isDescriptionTable}
        isTableLoading={tableConfig.isTableLoading}
        emptyLines={tableConfig.emptyLines}
        tableColumns={tableConfig.tableColumns}
        onChange={handleTableChange}
        scroll={tableConfig.scroll}
      />
    </Fragment>
  );
};

MissedQuestionsTopHundredSection.propTypes = {
  data: PropTypes.array,
  sectionTitle: PropTypes.string,
  isLoading: PropTypes.bool,
  renderOnlyTable: PropTypes.bool
};

export default MissedQuestionsTopHundredSection;
